import { getSelectedBlocks } from "lib/helpers";


/**
 * @param {Draft.EditorState} editorState
 */
export function getSelectedText(editorState) {
	const content = editorState.getCurrentContent();
	const selection = editorState.getSelection();
	const startBlock = content.getBlockForKey(selection.getStartKey());
	const endBlock = content.getBlockForKey(selection.getEndKey());

	const blocks = getSelectedBlocks(editorState);

	return blocks.map(block => block.getText()).toArray().join('\n');
}



// WEBPACK FOOTER //
// ./lib/helpers/getSelectedText.js